import { render, staticRenderFns } from "./LeadFormWrapper.vue?vue&type=template&id=54e210cc&"
import script from "./LeadFormWrapper.vue?vue&type=script&lang=js&"
export * from "./LeadFormWrapper.vue?vue&type=script&lang=js&"
import style0 from "@v4/common/components/organisms/LeadFormWrapper/_index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports